import React from 'react';

import { Icon } from '@atoms';
import { Flex, Typography } from '@mixins';
import { theme } from '@styles';

import { ReactComponent as DropdownIcon } from '@assets/svgs/Dropdown.svg';
import { func, node, number, oneOfType, string } from 'prop-types';

const Dropdown = ({ title, value, defaultValue, onDropdownClick, children, ...props }) => {
  return (
    <Flex flexDirection="column" {...props}>
      {title && (
        <Typography mb={10} variant="rightserif-400" fontSize={[15, 16, 17]}>
          {title}
        </Typography>
      )}
      <Flex
        justifyContent="space-between"
        width="100%"
        pointer
        onClick={onDropdownClick}
        borderBottom={`1px solid ${theme.color.gray[500]}`}
        alignItems="center">
        <Typography
          color={value ? theme.color.black : theme.color.gray[200]}
          variant="diatype-400"
          fontSize={[14, 15, 16]}
          mb="5px">
          {value || defaultValue}
        </Typography>
        <Icon SVG={DropdownIcon} height={[6, 6, 10, 14]} color={theme.color.black} />
      </Flex>
      {children}
    </Flex>
  );
};

Dropdown.propTypes = {
  children: node,
  value: oneOfType(string, number).isRequired,
  title: oneOfType(string, number),
  onDropdownClick: func.isRequired,
  defaultValue: oneOfType(string, number).isRequired,
};

Dropdown.defaultProps = {
  title: null,
  children: <></>,
};

export default Dropdown;
